<script>
import ProcessFlowForm from "@/driver/pages/masters/recycle_disposal_patterns/flows/_Form.vue";

export default {
  name: "MasterFlowNew",
  components: {
    ProcessFlowForm,
  },
  props: {},
  data () {
    return {
      breadcrumbs: [
        { text: '再資源化等パターン', disabled: false, to: '/driver/masters/recycle_disposal_patterns', exact: true },
        { text: '処理フロー登録', disabled: true, to: '' },
      ]
    }
  },
  watch: {},
  computed: {},
  created() {},
  methods: {}
}
</script>

<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <process-flow-form />

  </v-container>
</template>

<style scoped lang="scss">

</style>
